/**
 * Cliente HTTP de Branding: wrappers tipados sobre `req()` de campana-nueva. Nunca se manda el comercio (sale del
 * token). Es del equipo: con el token de una persona de un cliente, el backend dice 403.
 */

import { req } from "../campana-nueva/api";
import type { Resp } from "../wa-oficial/api";
import type * as T from "./types";

const B = "/activa/branding";

export const brandingApi = {
  ver: (): Promise<Resp<T.Branding>> => req("GET", B),
  guardar: (identidad: T.IdentidadParaGuardar): Promise<Resp<T.Branding>> => req("PUT", B, identidad),
};
